






import TopNavigationBar from "@/components/TopNavigationBar";
import { mapMutations, mapGetters } from "vuex";

export default {
  name: "Header",
  components: {
    TopNavigationBar
  },
  computed: {
    ...mapGetters({
      isMobile: "isMobile"
    }),
    isHome() {
      return this.$router.currentRoute.path === "/";
    }
  },
  created() {
    window.addEventListener("resize", this.onResize);
    this.onResize();
  },
  destroyed() {
    window.removeEventListener("resize", this.onResize);
  },
  methods: {
    ...mapMutations({
      setScreen: "setScreen"
    }),
    onResize() {
      this.setScreen(window.innerWidth);
    }
  }
};
